export const saveToLocalStorage = (key, value) => {
	try {
		const serializedItem = JSON.stringify(value);
		localStorage.setItem(key, serializedItem);
	} catch (err) {
		//ignore
	}
}

export const loadFromLocalStorage = (key) => {
	try {
		const serializedItem = localStorage.getItem(key);
		if (serializedItem === null)
			return undefined;
		return JSON.parse(serializedItem);
	} catch (err) {
		return undefined;
	}
}


// WEBPACK FOOTER //
// ./src/utils/localStorageManager.js